export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fdc72a950d50fe401d528f49f294f0433ec8eecda&name=fetchTypeahead!'